import styled from 'styled-components';

export const UsageWrapper = styled.div`
  margin-bottom: 32px;
`;

export const UsageTitle = styled.p`
  ${(props) => props.theme.typography.subHeader2}
`;

export const UsageSubtitle = styled.p`
  color: ${(props) => props.theme.colors.muted};
`;

export const RiskWrapper = styled.div`
  padding-top: 24px;
`;
